import usePrivateAxios from "@/common/api/usePrivateAxios";
import { defaultTransformerResponse } from "@/common/constants/defaultTransformerResponse.constant";
import { Mapper } from "@/common/services/mapper";
import { MetaResponse } from "@/common/types/metaResponse";
import { keepPreviousData, useQuery } from "@tanstack/react-query";
import { WorkflowScheduleKind } from "../types/workflowSchedules.type";

type UseMaintenanceWorkflowSchedulesProps<T> = {
  filters?: {
    search?: string;
    page?: number;
    companyId?: string
    kind?: WorkflowScheduleKind
  };
  mapper?: (data: any) => T,
};

export const useMaintenanceWorkflowSchedules = <T,>({
  filters: { search, page, companyId, kind } = {},
  mapper = Mapper.default<T>(),
}: UseMaintenanceWorkflowSchedulesProps<T>) => {
  const privateAxios = usePrivateAxios()

  const {
    data: { data, meta } = defaultTransformerResponse<T>(),
    ...rest
  } = useQuery({
    queryKey: ['maintenanceWorkflowSchedules', search, page, companyId, kind],
    queryFn: () => {
      return privateAxios.get(`/maintenance/workflow_schedules`, {
        params: {
          search,
          page,
          // 'q[company_id_eq]': companyId,
          'q[kind_eq]': kind
        }
      });
    },
    select: (data: { data: { data: any[], meta: MetaResponse; }; }) => {
      return {
        data: mapper(data?.data?.data),
        meta: data?.data?.meta,
      };
    },
    placeholderData: keepPreviousData,
  });

  return { data, meta, ...rest };
};
